import {useState, useEffect} from 'react';
import {db} from '../firebase/firebaseConfig';
import {useAuth} from '../context/AuthContext';
import { collection, onSnapshot, query, where } from 'firebase/firestore';

const useOrders = () => {
	const [orders, setOrders] = useState([]);
	const {usuario} = useAuth();

	const formatDate = (d) => {
		const x = new Date(d.dueDate*1000).toISOString().split('T')[0];
		return x.split('-').reverse().join('/');
	}

	useEffect(() => {
		if(usuario){
			const queryDB = query(
				collection(db, 'orders'),				
				where('userId', '==', usuario.uid)
			);

			const unsuscribe = onSnapshot(queryDB, (snapshot) => {
				setOrders(snapshot.docs.map((documento) => {
					return {...documento.data(), displayDate: formatDate(documento.data()), id: documento.id}
				}))
			}, (error) => {return error});

			return unsuscribe;
		}
	}, [usuario]);

	return orders;
}
 
export default useOrders;
